<template>
    <div>
        <div v-if="hasData">
            <HistoryRedeemReceiveItem
                v-for="(campaign,index) in list"
                :key="campaign.id"
                :keyIndex="index"
                :campaign="campaign"
            ></HistoryRedeemReceiveItem>
        </div>
        <div v-else class="">  
            <NoData></NoData>
        </div>
    </div>
</template>

<script>
import HistoryRedeemReceiveItem from '../Item/HistoryRedeemReceiveItem.vue'
import NoData from '@/module/History/component/NoData.vue'
export default {
    name: 'HistoryRedeemReceive',
    components:{
        HistoryRedeemReceiveItem,
        NoData,
    },
    props:{
        list: Array,
        modalController: Object
    },
    computed:{
        hasData: function(){
            return this.list.length
        }
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.line{
    height: 0.5px;
    transform: rotate(-180deg);
}
</style>
